import { createRoot } from 'react-dom/client'
import * as styles from '@common/EmbedHome.module.scss'
import App from './App'

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('app-loteria-nadal')
	const lang = document.documentElement.lang || 'ca'
	const preview = new URLSearchParams(window.location.search).get('preview') === '1'
	const embedHome =
		new URLSearchParams(window.location.search).get('embed-home') === '1' || container.dataset.embedHome === '1'
	if (embedHome) {
		container.classList.add(styles.containerHome)
		container.style.paddingInline = '0'
	}
	const root = createRoot(container)
	root.render(<App lang={lang} preview={preview} embedHome={embedHome} />)
})
